import { render, staticRenderFns } from "./AddPack.vue?vue&type=template&id=757fdc21&scoped=true&"
import script from "./AddPack.vue?vue&type=script&lang=js&"
export * from "./AddPack.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style2 from "./AddPack.vue?vue&type=style&index=2&id=757fdc21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757fdc21",
  null
  
)

export default component.exports